import React, { createContext, memo } from 'react';
import { Box, CircularProgress } from '@mui/material';
import MessagesShow from './components/messages-show';
import { MessageHookType } from '../../type/chat.types';
import useMessages from './hooks';

export const MessageContext = createContext<MessageHookType | null>(null);

const ChatMessages = (props: any) => {
    const messageHook: MessageHookType = useMessages(props);
    const { isLoadingNewMessages, scrollPosition, containerRef, onScroll } =
        messageHook;

    return (
        <MessageContext.Provider value={messageHook}>
            <Box
                id="messagesContainer"
                ref={containerRef}
                onScroll={onScroll}
                sx={{
                    height: '100%',
                    overflowY: 'auto',
                    scrollBehavior: !scrollPosition ? 'smooth' : 'auto',
                    px: { xs: 1.25, md: 2.5 },
                    py: 2,
                    scrollbarWidth: 'none',
                    msOverflowStyle: 'none',
                    '&::-webkit-scrollbar': { display: 'none' },
                }}>
                {isLoadingNewMessages && (
                    <Box
                        sx={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            pb: 3,
                        }}>
                        <CircularProgress size={28} />
                    </Box>
                )}
                <MessagesShow />
            </Box>
        </MessageContext.Provider>
    );
};

export default memo(ChatMessages);
